import {useState} from 'react'
import {logger, meta} from 'tizra'
import * as B from '../block'
import {Admin} from './admin'
import {Complex} from './Complex'
import {meta as metadata} from './meta'
import {Simple} from './Simple'

const log = logger('ImageBlock')

export const ImageBlock = B.blockWithInfo(
  {...metadata, Admin, dividers: false},
  ({
    config: {
      tizraId,
      imageUrl,
      altText,
      linkUrl,
      width,
      fitting,
      focus,
      maxHeight,
      maxWidth,
      position,
    },
  }) => {
    const [errored, setErrored] = useState<string>()
    const metaObj = B.useMetaObj({tizraId, options: {alertOnError: false}})

    if (tizraId) {
      imageUrl = `/${tizraId}/~stream`
      altText = meta.string(metaObj, 'Description') || ''
    }

    if (!imageUrl || errored === imageUrl) {
      return null
    }

    const image =
      maxWidth || maxHeight || fitting === 'scale-down' ?
        <Complex
          imageUrl={imageUrl}
          altText={altText}
          linkUrl={linkUrl}
          maxHeight={maxHeight}
          maxWidth={maxWidth}
          fitting={fitting}
          position={position}
          focus={focus}
          setErrored={setErrored}
        />
      : <Simple
          imageUrl={imageUrl}
          altText={altText}
          linkUrl={linkUrl}
          setErrored={setErrored}
        />

    return (
      <B.Section
        bleed={width === 'bleed'}
        variant="abutting"
        {...B.tid('ImageBlock-section')}
      >
        {image}
      </B.Section>
    )
  },
)
